import React from 'react';
import { IconButton, Toolbar, Typography } from '@mui/material';
import AddIconMU from '@mui/icons-material/Add';
import DeleteIconMU from '@mui/icons-material/Delete';
import PersonIcon from '@mui/icons-material/Person';
import SearchIcon from '@mui/icons-material/Search';

export default function EnhancedTableToolbar({
  numSelected,
  onInvite,
  onAddUser,
  toggleFilters,
  onDeleteUser,
}) {
  return (
    <Toolbar sx={{ paddingRight: 2 }}>
      <div style={{ flex: '0 0 auto' }}>
        {numSelected > 0 && (
          <Typography color="inherit" variant="subheading">
            {numSelected} selected
          </Typography>
        )}
      </div>
      <div style={{ flex: '1 1 100%' }} />
      <div style={{ display: 'flex' }}>
        <IconButton aria-label="Invite" onClick={onInvite}>
          <PersonIcon />
        </IconButton>
        <IconButton aria-label="Add" onClick={onAddUser}>
          <AddIconMU />
        </IconButton>
        <IconButton aria-label="Search" onClick={toggleFilters}>
          <SearchIcon />
        </IconButton>
        <IconButton
          aria-label="Delete"
          disabled={numSelected === 0}
          onClick={onDeleteUser}
        >
          <DeleteIconMU />
        </IconButton>
      </div>
    </Toolbar>
  );
}
